<template>
  <el-dialog title="新增人脸库信息" :visible.sync="visible" width="700px" :before-close="closeDialog">
    <el-form ref="form" :model="bucket" :rules="rules" style="width:600px" label-width="100px">
      <el-form-item label="名称" prop="name">
        <el-input v-model="bucket.name"></el-input>
      </el-form-item>
      <el-form-item label="有效期" prop="_expired">
        <el-radio-group v-model="bucket._expired">
          <el-radio label="6 months">半年</el-radio>
          <el-radio label="1 years">一年</el-radio>
          <el-radio label="3 years">三年</el-radio>
          <el-radio :label="0">无限期</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item align="center">

        <el-button @click="$refs.form.resetFields()">重 置</el-button>
        <el-button type="primary" @click="submit">提 交</el-button>
      </el-form-item>
    </el-form>
    <!--<span slot="footer" class="dialog-footer">
    </span>-->
  </el-dialog>
</template>

<script>
import { rules } from "@/utils";
import moment from "moment";
import { mapActions } from "vuex";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bucket: {
        name: "",
        _expired: "1 years"
      },
      rules: {
        name: [rules.required()]
      }
    };
  },
  methods: {
    ...mapActions("bucket", ["add"]),
    async submit() {
      let ok = await this.$refs.form.validate();
      if (!ok) {
        return;
      }
      let expired = this.bucket._expired;
      if (expired === 0) {
        expired = undefined;
      } else {
        let [n, unit] = expired.split(" ");
        expired = moment()
          .add(parseInt(n), unit)
          .valueOf();
      }
      let res = await this.add({ ...this.bucket, expired });
      this.$message.success("新增成功");
      this.closeDialog();
    },
    closeDialog(){
      this.$emit('update:visible', false);
      this.$refs.form.resetFields();
    }
  }
};
</script>

<style>
</style>

